var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlowOrganizations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H76C78.2091 0 80 1.79086 80 4V76C80 78.2091 78.2091 80 76 80H4C1.79086 80 0 78.2091 0 76V4Z",
    fill: "#5F11EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5486_3065",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5486_3065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1112 55C25.3612 55 24.7106 54.7246 24.1595 54.1738C23.6087 53.6226 23.3333 52.9721 23.3333 52.2221V32.7779C23.3333 32.0279 23.6087 31.3774 24.1595 30.8263C24.7106 30.2754 25.3612 30 26.1112 30H33.3333V26.1113C33.3333 25.3613 33.6087 24.7107 34.1595 24.1596C34.7106 23.6088 35.3612 23.3333 36.1112 23.3333H43.8887C44.6387 23.3333 45.2892 23.6088 45.8403 24.1596C46.3912 24.7107 46.6666 25.3613 46.6666 26.1113V30H53.8887C54.6387 30 55.2892 30.2754 55.8403 30.8263C56.3912 31.3774 56.6666 32.0279 56.6666 32.7779V52.2221C56.6666 52.9721 56.3912 53.6226 55.8403 54.1738C55.2892 54.7246 54.6387 55 53.8887 55H26.1112ZM36.1112 30H43.8887V26.1113H36.1112V30ZM53.8887 44.6946H44.1945V47.4721H35.8612V44.6946H26.1112V52.2221H53.8887V44.6946ZM38.6387 44.6946H41.4166V41.9167H38.6387V44.6946ZM26.1112 41.9167H35.8612V39.1388H44.1945V41.9167H53.8887V32.7779H26.1112V41.9167Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowOrganizations);
export default __webpack_public_path__ + "static/media/icon-flow-organizations.81bd78cee76b97f6d28cbadf4b45f9fc.svg";
export { ForwardRef as ReactComponent };